import React from 'react'
import bugsnag from '@bugsnag/js'
import bugsnagReact from '@bugsnag/plugin-react'
import getConfig from 'next/config'
import { isDev, version } from '../env'

const bugsnagClient = bugsnag({
  apiKey: 'd6044a13f05c8d5e0cc7a1ec1a62bcf1',
  appVersion: version,
  notifyReleaseStages: ['production'],
  releaseStage: isDev ? 'development' : 'production',
  metaData: {
    applicationStage: 'Next.js app',
  },
})

bugsnagClient.use(bugsnagReact, React)

export default bugsnagClient
